const applyDiscountEventHandler = async function (event) {
  const submitButton = event.currentTarget;
  const form = submitButton.form;

  var formData = new FormData(form);

  // Remove common form attributes that we don't need on the page refresh
  formData.delete(`authenticity_token`);
  formData.delete(`attendable_person_gid`);
  formData.delete(`cf-turnstile-response`);

  var redirectURL = new URL(submitButton.formAction);
  var newSearchParams = new URLSearchParams(formData);
  redirectURL.search = newSearchParams.toString();
  window.location.href = redirectURL.toString();

  event.preventDefault();
};

class ApplyDiscountElement extends HTMLElement {
  connectedCallback() {
    if (!this.isConnected) {
      return;
    }

    this.submitButtonElement.addEventListener(
      `click`,
      applyDiscountEventHandler,
    );
  }

  get submitButtonElement() {
    return this.querySelector(`:scope > button`);
  }
}

if (!window.customElements.get(`apply-discount`)) {
  window.customElements.define(`apply-discount`, ApplyDiscountElement);
}
